<template>
    <div>
        <div :class="{ 'show': toggleModal }" class="modal fade">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4 text-capitalize">
                            {{ title }}
                        </h5>
                        <button type="button" class="close" @click="toggleModal = false">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <div class="form-group">
                            <div class="input-group">
                                <div class="input-group-prepend w-100">
                                    <label class="input-group-text border-right-0">
                                        <i class="fas fa-user"></i>
                                    </label>
                                    <multiselect
                                        :value="selectedStaff"
                                        label="text"
                                        track-by="staffID"
                                        :options="staffs"
                                        :searchable="true"
                                        :show-labels="false"
                                        :allow-empty="false"
                                        openDirection="below"
                                        :disabled="this.dataID ? true : false"
                                        @select="onStaffChange">
                                        <template slot="option" slot-scope="{ option }">
                                            {{ option.text }}
                                        </template>
                                    </multiselect>
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <label class="h5">Repeat</label>
                            <select class="form-control" v-model="repeat" @change="onPreview">
                                <option value="weekly">Every Week</option>
                                <option value="fortnightly">Every 2 Weeks</option>
                                <option value="monthly">Monthly</option>
                                <!-- <option value="quarterly">Quarterly</option> -->
                            </select>
                        </div>

                        <div v-if="repeat === 'weekly'" class="form-group">
                            <label class="h5">Day of Week</label>
                            <select class="form-control" v-model="weekly" @change="onPreview">
                                <option value="1">Monday</option>
                                <option value="2">Tuesday</option>
                                <option value="3">Wednesday</option>
                                <option value="4">Thursday</option>
                                <option value="5">Friday</option>
                                <option value="6">Saturday</option>
                                <option value="0">Sunday</option>
                            </select>
                        </div>

                        <div v-if="repeat === 'fortnightly'" class="form-group">
                            <label class="h5">Day of Week</label>
                            <select class="form-control" v-model="fortnightly" @change="onPreview">
                                <option value="11">Monday - Starting this week</option>
                                <option value="21">Monday - Starting next week</option>
                                <option value="12">Tuesday - Starting this week</option>
                                <option value="22">Tuesday - Starting next week</option>
                                <option value="13">Wednesday - Starting this week</option>
                                <option value="23">Wednesday - Starting next week</option>
                                <option value="14">Thursday - Starting this week</option>
                                <option value="24">Thursday - Starting next week</option>
                                <option value="15">Friday - Starting this week</option>
                                <option value="25">Friday - Starting next week</option>
                                <option value="16">Saturday - Starting this week</option>
                                <option value="26">Saturday - Starting next week</option>
                                <option value="10">Sunday - Starting this week</option>
                                <option value="20">Sunday - Starting next week</option>

                                <!-- <option value="11">Monday - 1st, 3rd and 5th</option>
                                <option value="21">Monday - 2nd and 4th</option>
                                <option value="12">Tuesday - 1st, 3rd and 5th</option>
                                <option value="22">Tuesday - 2nd and 4th</option>
                                <option value="13">Wednesday - 1st, 3rd and 5th</option>
                                <option value="23">Wednesday - 2nd and 4th</option>
                                <option value="14">Thursday - 1st, 3rd and 5th</option>
                                <option value="24">Thursday - 2nd and 4th</option>
                                <option value="15">Friday - 1st, 3rd and 5th</option>
                                <option value="25">Friday - 2nd and 4th</option>
                                <option value="16">Saturday - 1st, 3rd and 5th</option>
                                <option value="26">Saturday - 2nd and 4th</option>
                                <option value="10">Sunday - 1st, 3rd and 5th</option>
                                <option value="20">Sunday - 2nd and 4th</option> -->
                            </select>
                        </div>

                        <div v-if="repeat === 'monthly'" class="form-group">
                            <label class="h5">Day of Month</label>
                            <select class="form-control" v-model="monthly" @change="onPreview">
                                <option v-for="index in Array.from(Array(31).keys())" :value="index + 1" :key="'monthly' + index">{{ (index + 1) + (String(index + 1).endsWith('1') ? 'st' : String(index + 1).endsWith('2') ? 'nd' : String(index + 1).endsWith('3') ? 'rd' : 'th') }}</option>
                            </select>
                        </div>

                        <div v-if="false" class="form-group">
                            <label class="h5">Start Date</label>
                            <date-range-picker
                                class="w-100"
                                ref="picker"
                                v-model="startDate"
                                :opens="'right'"
                                :singleDatePicker="true"
                                :timePicker="false"
                                :showDropdowns="true"
                                :ranges="false"
                                :always-show-calendars="true"
                                :minDate="startDateMin"
                                :maxDate="startDateMax"
                                :locale-data="{ firstDay: 1, format: 'ddd dd/mm/yyyy' }"
                                :autoApply="true"
                                :disabled="this.dataID ? true : false"
                                :append-to-body="true"
                                @update="onStartDateSelect">
                            </date-range-picker>
                        </div>

                        <div class="form-group">
                            <label class="h5">End Date</label>
                            <date-range-picker
                                class="w-100"
                                ref="picker"
                                v-model="endDate"
                                :opens="'right'"
                                :singleDatePicker="true"
                                :timePicker="false"
                                :showDropdowns="true"
                                :ranges="false"
                                :always-show-calendars="true"
                                :minDate="endDateMin"
                                :maxDate="endDateMax"
                                :locale-data="{ firstDay: 1, format: 'ddd dd/mm/yyyy' }"
                                :autoApply="true"
                                :disabled="this.dataID ? true : false"
                                :append-to-body="true"
                                @update="onStartDateSelect">
                            </date-range-picker>
                        </div>

                        <div v-if="preview && Object.keys(preview).length">
                            <label class="h5">Off Day will apply to:</label>
                            <div v-for="(value, month, i) in preview" :key="'preview_month' + i">
                                <u>{{ month }}</u>
                                <br>
                                <span v-for="(date, j) of value" :key="'preview_date' + date">{{ (j === 0 ? '' : ', ') + date}}</span>
                                <br>
                                <br>
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <div class="row w-100 no-gutters">

                            <div v-if="dataID" class="col-auto">
                                <button
                                    type="button"
                                    class="btn btn-danger waves-effect waves-themed mr-2"
                                    @click="showDeleteModal(dataID)">
                                    <i class="fal fa-trash"></i>
                                </button>
                            </div>

                            <div class="col">
                            </div>

                            <div class="col-auto">
                                <button
                                    type="button"
                                    class="btn btn-secondary waves-effect waves-themed"
                                    @click="toggleModal = false">
                                    {{ $t('button_link.cancel') }}
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-primary waves-effect waves-themed ml-2"
                                    @click="submitForm"
                                    :disabled="saveable">
                                    Save
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <deleteModal ref="deleteModal" @performConfirmAction="deleteFile"></deleteModal>
    </div>
</template>
<script>
import moment from 'moment'
import DeleteModal from './../../Delete_Modal.vue'
import DateRangePicker from 'vue2-daterange-picker'
import { handleSessionExpired } from './../../../../assets/js/dashboard/dashboard'
export default {
    name: 'ConsentFormForm',
    props: {
        isEdit: Boolean
    },
    components: {
        DateRangePicker,
        DeleteModal,
    },
    data() {
        return {
            toggleModal: false,

            title: '',
            saveable: false,

            dataID: 0,
            staffsAll: [],
            staffsFiltered: [],
            staffs: [],
            selectedStaff: {},
            startDate: {},
            endDate: {},
            repeat: 'weekly',

            weekly: 1,
            fortnightly: 11,
            monthly: 1,

            preview: {},

            exist: {},

            startDateMin: moment().startOf('day').format('YYYY-MM-DD'),
            startDateMax: moment().endOf('year').add(1, 'year').format('YYYY-MM-DD'),
            endDateMin: moment().startOf('day').format('YYYY-MM-DD'),
            endDateMax: moment().endOf('year').add(1, 'year').format('YYYY-MM-DD'),
        }
    },
    methods: {
        setStaffList(staffs) {
            this.staffsAll = staffs
            this.staffsFiltered = staffs.filter(k => k['enable'] && !k['deleteDate'])
        },
        setStaff(staff) {
            if(!staff || !staff['staffID']) {
                return
            }
            this.selectedStaff = staff
        },
        setLeaveTypes(types) {
            this.types = types
            this.selectedType = types[0]
        },
        setData(data) {
            this.exist = {}
            for(let temp of data) {
                let staffID = temp['staffID']

                let part = temp['info'].split('|')
                if(part.length < 4) {
                    continue
                }
                this.exist[staffID] = this.exist[staffID] || []
                this.exist[staffID] = this.exist[staffID].concat(this.calculateDate(part[0], moment(part[2], 'YYYY-MM-DD'), part[3] ? moment(part[3], 'YYYY-MM-DD') : null) || [], part[4])
            }
        },

        showModal(data) {
            this.toggleModal = true

            if (data) {
                this.title = 'Edit Off Day'

                this.dataID = data['schemeID']
                this.startDate = { startDate: moment.unix(data['startDate']), endDate: moment.unix(data['startDate']) }
                this.endDate = { startDate: moment.unix(data['endDate']), endDate: moment.unix(data['endDate']) }
                this.selectedType = this.types.find(k => k['typeID'] === data['typeID'])
                this.day = data['total']

                this.staffs = this.staffsAll
                this.selectedStaff = this.staffsAll.find(k => k['staffID'] === data['staffID']) || null

                return
            }

            this.title = 'Add Off Day'

            this.dataID = 0
            this.startDate = { startDate: null, endDate: null }
            this.endDate = { startDate: moment().endOf('year'), endDate: moment().endOf('year') }
            this.repeat = 'weekly'
            this.preview = []

            this.staffs = this.staffsFiltered

            this.previewDate()
        },
        closeModal(isError) {
        },

        onStaffChange(val) {
            this.selectedStaff = val
        },
        onStartDateSelect() {
            if(this.endDate.endDate && moment(this.endDate.endDate).unix() < moment(this.startDate.startDate).unix()) {
                let temp = moment(this.startDate.startDate).add(1, 'day').endOf('day')
                this.endDate = { startDate: temp, endDate: temp }
            }

            this.previewDate()
        },
        onEndDateSelect() {
            if(this.startDate.startDate && moment(this.endDate.endDate).unix() < moment(this.startDate.startDate).unix()) {
                let temp = moment(this.endDate.endDate).subtract(1, 'day').startOf('day')
                this.startDate = { startDate: temp, endDate: temp }
            }

            this.previewDate()
        },
        onPreview(val) {
            this.previewDate()
        },

        previewDate() {
            let month = {}
            let dates = (this.obtainDateList() || {})['dates'] || []
            for(let date of dates) {
                let temp = moment(date, 'YYYY-MM-DD')
                month[temp.format('MMM YYYY')] = month[temp.format('MMM YYYY')] || []
                month[temp.format('MMM YYYY')].push(temp.format('ddd DD/MM/YYYY'))
            }

            this.preview = month
        },

        obtainDateList() {
            if(!this.endDate.endDate || !this.repeat) {
                return
            }

            let today = moment().startOf('day')
            let start = moment(this.startDate.startDate).startOf('day')
            let end = moment(this.endDate.endDate).endOf('day')

            let nthWeekOfMonth = Math.floor(this.fortnightly / 10)

            if(this.repeat === 'weekly') {
                start = moment().days(this.weekly)
                if(start.unix() < today.unix()) {
                    start.add(1, 'week')
                }
            } else if(this.repeat === 'fortnightly') {
                let dayOfWeek = this.fortnightly % 10

                // start = this.getFirstOrSecondWeekdayOfMonth(today, dayOfWeek, nthWeekOfMonth)
                // while(start.unix() < today.unix()) {
                //     start.add(2, 'week')
                // }

                // if(start.month() !== today.month()) {
                //     start = this.getFirstOrSecondWeekdayOfMonth(start, dayOfWeek, nthWeekOfMonth)
                // }

                start = moment().days(dayOfWeek)
                if(this.fortnightly >= 20) {
                    start.add(1, 'week')
                }

                nthWeekOfMonth = 2
                let firstWeekdayOfMonth = this.getFirstOrSecondWeekdayOfMonth(start, dayOfWeek, 1)
                while(start.unix() > firstWeekdayOfMonth.unix()) {
                    nthWeekOfMonth = nthWeekOfMonth === 1 ? 2 : 1
                    firstWeekdayOfMonth.add(1, 'week')
                }
            } else if(this.repeat === 'monthly') {
                start = moment().date(this.monthly)
                if(start.unix() < today.unix()) {
                    start.add(1, 'month')
                }
            }

            let info = this.repeat + '|'
            if(this.repeat === 'weekly' || this.repeat === 'fortnightly') {
                info += start.format('dddd')
            } else if(this.repeat === 'monthly' || this.repeat === 'quarterly') {
                info += start.format('D')
            }
            info += '|' + start.format('YYYY-MM-DD')
            info += '|' + end.format('YYYY-MM-DD')

            if(this.repeat === 'fortnightly') {
                info += '|' + nthWeekOfMonth
            }

            let current = this.exist[this.selectedStaff['staffID']] || []
            let dates = []
            let temp = this.calculateDate(this.repeat, start, end, this.repeat === 'fortnightly' ? nthWeekOfMonth : null)
            for(let date of temp) {
                if(!current.includes(date)) {
                    dates.push(date)
                }
            }

            return {
                dates,
                info
            }
        },

        submitForm() {
            if (this.dataID) {
                this.updateData()
                return
            }

            this.addData()
        },
        addData() {
            let data = this.obtainDateList()

            let $vm = this
            $vm.$axios({
                method: 'post',
                url: 'https://staff.tunai.io/business/staff/' + this.selectedStaff['staffID'] + '/break/off',
                headers: {
                    token: $vm.$session.get('token'),
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify(data),
            })
                .then((response) => {
                    if (response.status == 200) {
                        this.toggleModal = false

                        var message = 'Successfully add off day'
                        $vm.$parent.$parent.setModal($vm, false, true, message)

                        this.$emit('onDataChange')
                    }
                })
                .catch((err) => {
                    var errData = err.response.data;
                    if (errData.error == $vm.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })
        },
        updateData() {
            let $vm = this
            $vm.$axios({
                method: 'post',
                url: 'https://staff.tunai.io/business/staff/' + this.selectedStaff['staffID'] + '/break/off' + this.dataID + '/update',
                headers: { token: $vm.$session.get('token') },
                data: {
                    startDate: moment(this.startDate.startDate).startOf('day').unix(),
                    endDate: moment(this.endDate.startDate).endOf('day').unix(),
                    total: this.day,
                    typeID: this.selectedType['typeID'],
                }
            })
                .then((response) => {
                    if (response.status == 200) {
                        this.toggleModal = false

                        var message = 'Successfully update off day'
                        $vm.$parent.$parent.setModal($vm, false, true, message)

                        this.$emit('onDataChange')
                    }
                })
                .catch((err) => {
                    console.log(err)
                    var errData = err.response.data;
                    if (errData.error == $vm.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })
        },

        showDeleteModal(dataID) {
            this.dataID = dataID
            var title = this.$i18n.t('header.delete_file')
            var message = 'Are you sure you want to delete this off day?'
            this.$refs.deleteModal.showModal(title, message)
        },
        deleteFile() {
            let $vm = this
            $vm.$axios({
                method: 'post',
                url: 'https://staff.tunai.io/business/staff/' + this.selectedStaff['staffID'] + '/break/scheme/' + this.dataID + '/delete',
                headers: { token: $vm.$session.get('token') },
            })
                .then((response) => {
                    if (response.status == 200) {
                        this.toggleModal = false

                        this.title = ''

                        var message = 'Successfully delete off day'
                        $vm.$parent.$parent.setModal($vm, false, true, message)

                        this.$emit('onDataChange')

                        this.$refs.deleteModal.toggleModal = false
                    }
                })
                .catch((err) => {
                    console.log(err)
                    var errData = err.response.data;
                    if (errData.error == $vm.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })
        },

        calculateDate(repeat, startM, endM, nthWeekOfMonth) {
            let dates = []
            let start = moment(startM)
            let end = endM ? moment(endM) : moment(startM).endOf('year')

            while(start.unix() < end.unix()) {
                dates.push(start.format('YYYY-MM-DD'))

                if(repeat === 'weekly') {
                    start.add(1, 'week')
                } else if(repeat === 'fortnightly') {
                    let currentMonth = start.month()
                    start.add(2, 'week')

                    // if(currentMonth !== start.month()) {
                    //     start = this.getFirstOrSecondWeekdayOfMonth(start, start.day(), nthWeekOfMonth)
                    // }
                } else if(repeat === 'monthly') {
                    start.add(1, 'month')
                } else if(repeat === 'quarterly') {
                    start.add(3, 'month')
                } else {
                    break
                }
            }

            return dates
        },
        getFirstOrSecondWeekdayOfMonth(date, dayOfWeek, nthWeekOfMonth) {
            let temp = moment(date).startOf('month').days(dayOfWeek)
            if(temp.month() !== date.month()) {
                temp.add(1, 'week')
            }

            if(nthWeekOfMonth === 2) {
                temp.add(1, 'week')
            }

            return temp
        },
    },
    async mounted() {
    }
}
</script>
<style scoped>
.error-validation {
    font-size: 0.6875rem;
    margin-top: 0.325rem;
    color: #fd3995;
}

#start-datepicker__dialog_ {
    display: none !important;
}

#start-datepicker__dialog_.show {
    display: block !important;
}

#end-datepicker__dialog_ {
    display: none !important;
}

#end-datepicker__dialog_.show {
    display: block !important;
}
</style>